import { useCallback } from 'react';
import type { GoodsCoupon } from 'shared/src/api';
import { useLogGoodsAnalyticsEvent } from '../../../hooks/useLogGoodsAnalyticsEvent';
import { CouponApplicableType, CouponIssuerType } from 'shared/src/constant';
import { useStackableCouponFlag } from 'shared/src/hooks';

export const useLogDownloadCoupon = () => {
  const logGoodsAnalyticsEvent = useLogGoodsAnalyticsEvent();
  const enableStackableFlag = useStackableCouponFlag();

  return useCallback(
    async (params: { coupon: GoodsCoupon; isDownloadAll: boolean }) => {
      logGoodsAnalyticsEvent({
        name: 'COMPLETE_DOWNLOAD_COUPON',
        analytics: {
          POSITION: 'BOTTOM_SHEET',
          IS_DOWNLOAD_ALL: params.isDownloadAll ? '1' : '0',
          ISSUER_TYPE: CouponIssuerType[params.coupon.issuer_type as 1 | 2],
          APPLICABLE_TYPE:
            CouponApplicableType[params.coupon.applicable_type as 1 | 2],
          ENABLE_STACKABLE_COUPON: enableStackableFlag ? '1' : '0',
          COUPON_SNO: params.coupon.sno.toString(),
          COUPON_NAME: params.coupon.name,
        },
      });
    },
    [enableStackableFlag, logGoodsAnalyticsEvent],
  );
};
